export default __webpack_public_path__ + "static/media/nodeJs.cccdafa9.svg";